<template>
    <kiosk-layout>
        <template v-slot:title>Cloning</template>
        <template v-slot:sidebar>
            <page-sidebar
                :links="[
                    { href: `/kiosk/cloning/targets`, label: 'Cloning Targets' },
                    { href: `/kiosk/cloning/teams`, label: 'Clone Teams' },
                ]"
            ></page-sidebar>
        </template>

        <slot></slot>
    </kiosk-layout>
</template>

<script setup>
import KioskLayout from '~/components/kiosk/KioskLayout.vue';
import PageSidebar from '~/components/general/PageSidebar.vue';
</script>
